<template>
  <div class="list">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        项目列表
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>

    <div style="width: 1056px;margin: 0 auto">
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table :data="tableData" border style="width: 100%" ref="multipleTable">
        <el-table-column prop="project_no" label="项目编号" align="center"></el-table-column>

        <el-table-column show-overflow-tooltip prop="project_name" label="项目名称" align="center"></el-table-column>

        <el-table-column prop="project_money" label="总金额" align="center"></el-table-column>

        <el-table-column show-overflow-tooltip prop="start_time" label="开始时间" align="center"></el-table-column>

        <el-table-column show-overflow-tooltip prop="end_time" label="结束时间" align="center"></el-table-column>

        <el-table-column label="设备" align="center" prop="facility"></el-table-column>

        <el-table-column prop="technical_service" label="技术服务" align="center"></el-table-column>
        <el-table-column prop="reagent" label="试剂" align="center"></el-table-column>
        <el-table-column prop="antibody" label="抗体" align="center"></el-table-column>
        <el-table-column prop="consume" label="耗材" align="center"></el-table-column>
        <el-table-column prop="others" label="其他" align="center"></el-table-column>
        <el-table-column prop="charge_name" label="负责人" align="center"></el-table-column>
        <el-table-column prop="money_source" label="资金来源" align="center"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return { serve: this.$store.state.serve,
      token: "",
      username: "",
      page: null,
      total: 0,
      tableData: [],
      id: this.$route.params.id
    };
  },
  created() {
    this.$store.state.leftTitle = "主账户功能";
    this.$store.state.topActiveId = 4;
    this.geting();
  },
  watch: {},
  methods: {
    geting() {
      this.token = this.$cookies.get("token");
      this.username = this.$cookies.get("username");
      this.axios
        .get(this.serve+"/admin/host_project", {
          params: {
            username: this.username,
            token: this.token,
            mobile: this.id
          }
        })
        .then(res => {
          this.tableData = [];
          if (res.data.status == 'success') {
            for (var key in res.data) {
              var time = res.data[key].start_time;
              var timeNew = new Date(parseInt(time) * 1000)
                .toLocaleString()
                .replace(/:\d{1,2}$/, " ");
                res.data[key].start_time = timeNew
              var time1 = res.data[key].end_time;
              var timeNew1 = new Date(parseInt(time1) * 1000)
                .toLocaleString()
                .replace(/:\d{1,2}$/, " ");
                res.data[key].end_time = timeNew1
              this.tableData.push(res.data[key]);
            }
          }
        });
    }
  }
};
</script>
<style lang="scss">
.list {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>